import React from "react";
import { Button, Empty, Tooltip } from "antd";
import {
  WhatsAppOutlined,
  CloseOutlined,
  ArrowLeftOutlined,
  ExportOutlined,
  PlusOutlined,
  SendOutlined,
} from "@ant-design/icons";
import ListaConversaciones from "../Chat/ListaConversaciones";
import HiloMensajes from "../Chat/HiloMensajes";
import { WA } from "../../theme";

const ANCHO_BURBUJA = 380;
const ALTO_NAVBAR = 64; 


const BurbujaWhatsapp = ({
  abierto,
  onCerrar,
  onAbrirVistaCompleta,
  conexionActiva,
  conversaciones,
  conversacionActiva,
  mensajes,
  loadingConversaciones,
  loadingMensajes,
  enviando,
  esMaster,
  numeroPorUsuario,
  miNumero,
  miLineaId,
  hayMas,
  cargandoMas,
  seleccionarConversacion,
  volverALista,
  cargarMasMensajes,
  enviarMensaje,
  enviarMediaArchivo,
  enviarPlantilla,
  enviarServicio,
  headersToken,
  empresaId,
  puedeGuardarPlantilla,
  puedeGuardarImagenInsumo,
  permisoMensajeMasivo,
  onNuevaConversacion,
  onMensajeMasivo,
  onVincularContacto,
}) => {
  const esMovil =
    typeof window !== "undefined" && window.innerWidth <= 1000;
  const ancho = esMovil ? "100vw" : ANCHO_BURBUJA;
  const enChat = !!conversacionActiva;

  return (

    <div
      style={{
        position: "fixed",
        top: ALTO_NAVBAR,
        right: 0,
        bottom: 0,
        width: ancho,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1000,
      }}
    >
      <style>{`
        .wa-scroll-verde { scrollbar-width: thin; scrollbar-color: ${WA.limaFuerte} transparent; }
        .wa-scroll-verde::-webkit-scrollbar { width: 6px; height: 6px; }
        .wa-scroll-verde::-webkit-scrollbar-track { background: transparent; }
        .wa-scroll-verde::-webkit-scrollbar-thumb { background-color: ${WA.limaFuerte}; border-radius: 8px; }
        .wa-scroll-verde::-webkit-scrollbar-thumb:hover { background-color: ${WA.lima}; }
      `}</style>
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: WA.surface,
          borderLeft: `1px solid ${WA.border}`,
          boxShadow: "-2px 0 10px rgba(0,0,0,0.12)",
          display: "flex",
          flexDirection: "column",
          transform: abierto ? "translateX(0)" : "translateX(100%)",
          visibility: abierto ? "visible" : "hidden",
          transition: "transform 0.25s ease, visibility 0.25s ease",
          pointerEvents: abierto ? "auto" : "none",
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            padding: enChat ? "6px 8px" : "10px 12px",
            borderBottom: `1px solid ${WA.border}`,
            backgroundColor: WA.surface,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            {enChat ? (
              <Button
                type="text"
                size="small"
                icon={<ArrowLeftOutlined />}
                onClick={volverALista}
              />
            ) : (
              <WhatsAppOutlined style={{ fontSize: 18, color: WA.lima }} />
            )}
            <span
              style={{
                fontWeight: 600,
                color: WA.textPrimary,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {enChat ? "Conversación" : "WhatsApp"}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {!enChat && onNuevaConversacion && (
              <Tooltip title="Nueva conversación">
                <Button
                  type="text"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={onNuevaConversacion}
                  style={{ color: WA.limaFuerte }}
                />
              </Tooltip>
            )}
            {!enChat && permisoMensajeMasivo && onMensajeMasivo && (
              <Tooltip title="Mensaje masivo">
                <Button
                  type="text"
                  size="small"
                  icon={<SendOutlined />}
                  onClick={onMensajeMasivo}
                  style={{ color: WA.naranja }}
                />
              </Tooltip>
            )}
            <Button
              type="text"
              size="small"
              icon={<ExportOutlined />}
              onClick={onAbrirVistaCompleta}
            />
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={onCerrar}
            />
          </div>
        </div>

        {/* Cuerpo */}
        {conexionActiva === false ? (
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
            <Empty
              image={<WhatsAppOutlined style={{ fontSize: 44, color: WA.lima }} />}
              description="WhatsApp no está conectado."
            />
          </div>
        ) : enChat ? (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            <HiloMensajes
              conversacion={conversacionActiva}
              mensajes={mensajes}
              loading={loadingMensajes}
              enviando={enviando}
              onEnviar={enviarMensaje}
              onEnviarMedia={enviarMediaArchivo}
              onEnviarServicio={enviarServicio}
              onEnviarPlantilla={enviarPlantilla}
              headersToken={headersToken}
              empresaId={empresaId}
              puedeGuardarPlantilla={puedeGuardarPlantilla}
              puedeGuardarImagenInsumo={puedeGuardarImagenInsumo}
              hayMas={hayMas}
              cargandoMas={cargandoMas}
              onCargarMas={cargarMasMensajes}
              onVincularContacto={onVincularContacto}
            />
          </div>
        ) : (
          <div className="wa-scroll-verde" style={{ flex: 1, overflowY: "auto" }}>
            <ListaConversaciones
              conversaciones={conversaciones}
              loading={loadingConversaciones}
              conversacionActivaId={conversacionActiva?._id}
              onSelect={seleccionarConversacion}
              esMaster={esMaster}
              numeroPorUsuario={numeroPorUsuario}
              miNumero={miNumero}
              miLineaId={miLineaId}
            />
            {/* Los botones de "Nueva conversación" y "Masivo" se muestran en el header de la burbuja, no aquí */}
          </div>
        )}
      </div>
    </div>
  );
};

export default BurbujaWhatsapp;
